import axios, { AxiosResponse } from 'axios'
import ERROR_MESSAGE from 'config/errorMessage'
import ID_COMPONENTE from 'config/idComponente'
import { rest } from 'lodash'
import handleErrors from 'Services/handleErrors'

import hosts from '../config/microServices'
import handleToken from './handleToken'
import ResponseRevalidateToken from './UAA/types/response/RevalidateToken'

interface ApiServiceProps {
  anonymous?: boolean
  upload?: boolean
  idComponente?: number
}

const ApiService = (props?: ApiServiceProps) => {
  let token: string | null
  if (!props || !props?.anonymous) {
    //Se não permite requisição anonima
    token = handleToken.getToken()
  }

  const service = axios.create({
    headers: {
      csrf: 'token',
    },
  })

  service.interceptors.request.use(
    async (config) => {
      config.headers = {
        Accept: 'application/json',
        'Content-Type': props?.upload
          ? 'application/x-www-form-urlencoded'
          : 'application/json-patch+json',
      }

      if (token !== null && token !== undefined) {
        config.headers = {
          ...rest,
          Authorization: `Bearer ${token}`,
          idComponente: props?.idComponente || ID_COMPONENTE.DOCAS,
        }
      }

      return config
    },
    (error) => {
      Promise.reject(error)
    },
  )
  service.interceptors.response.use(async (response: AxiosResponse) => {
    if (response.data.statusCode === 2) {
      location.assign('/session-close')
    }
    return response
  }, handleErrors)

  return {
    get<T = any>(url: string): Promise<AxiosResponse> {
      return service.get<T>(url)
    },
    post<T = any>(url: string, data?: any): Promise<AxiosResponse> {
      return service.post<T>(url, data)
    },
    put<T = any>(url: string, data: any): Promise<AxiosResponse> {
      return service.put<T>(url, data)
    },
    delete<T = any>(url: string, data: any): Promise<AxiosResponse> {
      return service.delete<T>(url, data)
    },
  }
}

export default ApiService
